export const categories = [
  {
    id: "top-stars",
    name: "顶流追踪",
    desc: "顶流动向、行程路透与数据变化，第一时间汇集。",
    icon: "ri-fire-line",
    count: 128,
  },
  {
    id: "film-tv",
    name: "影视剧透",
    desc: "剧集番位、选角变动与拍摄现场的零散风向。",
    icon: "ri-clapperboard-line",
    count: 96,
  },
  {
    id: "variety",
    name: "综艺风波",
    desc: "录制话题、嘉宾互动与节目组台前幕后的讨论。",
    icon: "ri-mic-line",
    count: 74,
  },
  {
    id: "music",
    name: "音乐圈事",
    desc: "新歌发布、版权归属与舞台表现的热议整理。",
    icon: "ri-music-2-line",
    count: 61,
  },
  {
    id: "fashion",
    name: "时尚资源",
    desc: "代言、封面与活动造型的商务资源变动观察。",
    icon: "ri-vip-diamond-line",
    count: 53,
  },
  {
    id: "live",
    name: "带货直播",
    desc: "直播间名场面、选品争议与售后反馈的集中整理。",
    icon: "ri-live-line",
    count: 45,
  },
  {
    id: "relationship",
    name: "情感瓜田",
    desc: "同框、互动与官宣节奏，按时间线梳理来龙去脉。",
    icon: "ri-heart-3-line",
    count: 88,
  },
  {
    id: "backstage",
    name: "幕后爆料",
    desc: "剧组日常、团队变动与行业侧耳倾听的碎片信息。",
    icon: "ri-file-list-3-line",
    count: 39,
  },
];